import { Component, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { ModalService } from '@eg/ui';
import { NotificationCenterDetailsComponent } from '../notification-center-details/notification-center-details.component';
import { Overlay } from '@angular/cdk/overlay';
import { NotificationCenterStore } from '../../store/notification-center.store';
import { take, tap } from 'rxjs';

@Component({
  selector: 'rmb-notification-center-navigation-item',
  standalone: true,
  imports: [RouterModule, TooltipModule, TranslocoModule],
  templateUrl: './notification-center.component.html',
  styleUrl: './notification-center.component.scss',
})
export class NotificationCenterNavigationItemComponent {
  private modalService = inject(ModalService);
  private overlay = inject(Overlay);
  readonly notificationCenterStore = inject(NotificationCenterStore);

  openNotificationModal() {
    this.modalService
      .open({
        title: null,
        overlayClass: 'sidepanel-right',
        width: '365px',
        content: NotificationCenterDetailsComponent,
        data: {},
        positionStrategy: this.overlay.position().global().end(),
      })
      .afterClosed$.pipe(
        take(1),
        tap(() => this.notificationCenterStore.fetchLoopNotifications())
      )
      .subscribe();
  }
}
